import { getCookie } from '@utiljs/cookie';
import { getStorage, removeStorage } from '@utils/localStorage';
import { stringify } from '@utiljs/param';
import isSafeUrl from '@utils/isSafeUrl';
import Horn from '@utils/horn';
import set from '@utils/set';
import { getEnv, ENV, isSwimlane, getCurrentSwimlaneName } from '@utils/getEnv';

import getProxyGrayPage from './proxyGrayPage';

/**
 * proxy token in URL 问题改造命中灰度的proxy路径
 */
let proxyTokenInUrlFixWhiteList: string[] = [];

const updateProxyTokenInUrlFixWhiteList = (whiteList: string[]) => {
    proxyTokenInUrlFixWhiteList = whiteList;
};
interface Iparams {
    _source: string;
    /**
     * proxy token in URL 问题改造后，命中灰度的proxy路径不再透传token 、
     *
     * 背景：https://km.sankuai.com/page/1277937820
     */
    token?: string;
    acctId: string;
    wmPoiId: string;
    region_id: string;
    device_uuid: string;
    bsid: string;
    appType: string;
    fromPoiChange: boolean;
    userId: string;
    topOrigin: string;
}

interface IparamsGoods {
    wmPoiId: string;
}

const goPager = (hash: string): string | null => {
    const fromPoiChange = getStorage('fromPoiChange');
    removeStorage('fromPoiChange');

    if (hash) {
        // waimaie重构新页面灰度处理：判断是否跳转到新的页面，如果是这返回新的url，否则返回原来url
        hash = getProxyGrayPage(hash);
        let targetHref = hash;
        // 如果是完整路径，则需要校验下是否是合法的eappBaseUrl
        if (targetHref.indexOf('http') === 0 || targetHref.indexOf('/reuse/product') !== -1) {
            let params: Iparams | IparamsGoods = {
                _source: 'PC',
                token: getCookie('token'),
                acctId: getCookie('acctId'),
                wmPoiId: getCookie('wmPoiId'),
                region_id: getCookie('region_id'),
                // eslint-disable-next-line @typescript-eslint/camelcase
                device_uuid: getCookie('device_uuid'),
                bsid: getCookie('bsid'),
                appType: '3',
                fromPoiChange: !!fromPoiChange,
                userId: '',
                topOrigin: encodeURIComponent(window.location.origin),
            };
            if (targetHref.indexOf('csCenter') !== -1) {
                params.userId = params.wmPoiId;
            }
            //商品页面传参
            if (targetHref.indexOf('/reuse/product') !== -1) {
                params = {
                    wmPoiId: getCookie('wmPoiId'),
                };
            }

            // 如果命中 Proxy token in URL 改造，则移除通参中的 token 字段
            if (
                window.CommConstants &&
                window.CommConstants.eappBaseUrl &&
                targetHref.indexOf(window.CommConstants.eappBaseUrl) !== -1
            ) {
                if (proxyTokenInUrlFixWhiteList.some(path => targetHref.indexOf(path) !== -1)) {
                    if ('token' in params) {
                        delete params.token;
                    }
                    if ('bsid' in params) {
                        delete params.bsid;
                    }
                }
            }

            const hrefParts = targetHref.split('#');
            let paramStr =
                typeof hrefParts[0] === 'string' && hrefParts[0].indexOf('?') > 0 ? '&' : '?';
            paramStr += stringify(params);
            targetHref =
                hrefParts[0] +
                paramStr +
                (hrefParts && hrefParts.length > 1 ? `#${hrefParts[1]}` : '');
        }

        // fe_core 页面是否走gw转发
        if (targetHref.match(/^\/new_fe\/business\b/)) {
            // 读取gw开关
            const coreBusinessUseGw = Horn.getConfigByFieldName<boolean>(
                Horn.CONFIG_FIELD.CORE_BUSINESS_USE_GW,
            );

            if (coreBusinessUseGw !== null && coreBusinessUseGw) {
                targetHref = targetHref.replace(/^\/new_fe\/business\b/, '/new_fe/business_gw');
            }
        }

        // 应用和平台使用的协议保持一致
        if (window.location.protocol === 'https:' && targetHref.indexOf('http:') === 0) {
            targetHref = targetHref.replace('http:', 'https:');
        }

        /**
         * 线上存在双域名容灾，如果hash里包含了全域名，需要和外层页面域名调整到一致
         * 例如访问  https://e.waimai.meituan.com#/https://waimaie.meituan.com/v2/index
         * 需要将 iframe 实际访问的url替换为 https://e.waimai.meituan.com/v2/index
         */
        if (getEnv() === ENV.PRODUCTION) {
            if (window.location.host === 'waimaie.meituan.com') {
                targetHref = targetHref.replace(/\be\.waimai\.meituan\.com/, 'waimaie.meituan.com');
            } else {
                targetHref = targetHref.replace(/\bwaimaie\.meituan\.com/, 'e.waimai.meituan.com');
            }
        }

        /** 泳道环境跳转proxy域名时检测跳转地址是否同样为泳道，如果是主干地址，则自动切换到外层页面相同的泳道 */
        if (isSwimlane) {
            // proxy服务主干host
            const proxyHost = (window.CommConstants.eappBaseUrl || '').replace(/https?:\/\//, '');
            const match = targetHref.match(/^(https?:)?(\/\/)?([^/?]+)/i);
            if (match) {
                const targetHost = match[3];
                if (targetHost.indexOf('-sl-') === -1 && targetHost === proxyHost) {
                    targetHref = targetHref.replace(
                        targetHost,
                        `${getCurrentSwimlaneName()}-sl-${proxyHost}`,
                    );
                }
            }
        }

        if (isSafeUrl(targetHref)) {
            // 内部跳转添加SET化参数（不带域名的url）
            const setParams = set.getParams();
            if (
                setParams &&
                targetHref.indexOf('http') === -1 &&
                targetHref.indexOf('/reuse/product') === -1
            ) {
                const searchIndex = targetHref.indexOf('?');
                if (searchIndex === -1) {
                    // 没有“?”，则加上“?”
                    targetHref += '?';
                } else if (searchIndex !== targetHref.length - 1) {
                    // “?”不在最后，则加上“&”
                    targetHref += '&';
                }
                // 添加参数
                let paramsStr = '';
                if (setParams) {
                    paramsStr = stringify(setParams);
                }
                targetHref += paramsStr;
            }
            const noJump = Boolean(getStorage('nojump'));

            if (!noJump) {
                return targetHref;
            }

            return hash;
        }
    }
    // @ts-ignore
    window.sameSrc = false;
    // @ts-ignore
    window.onmessage = function(e) {
        if (e.data === '同源子域') {
            // @ts-ignore
            window.sameSrc = true;
        }
    };
    return null;
};

export default goPager;
export { updateProxyTokenInUrlFixWhiteList };
